import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import api from '../lib/api';
import { toast } from 'sonner';

const EMPTY = { current: '', next: '', confirm: '' };

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const handleOpenChange = (v) => { if (!v) setForm(EMPTY); onOpenChange(v); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.next !== form.confirm) { toast.error('Konfirmasi password tidak sama'); return; }
    setSaving(true);
    try {
      await api.post('/auth/change-password', { current_password: form.current, new_password: form.next });
      toast.success('Password berhasil diganti. Silakan login dengan password baru.');
      handleOpenChange(false);
      logout();
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal mengganti password');
    } finally {
      setSaving(false);
    }
  };

  const field = (key, label, testid) => (
    <div className="space-y-1">
      <Label>{label}</Label>
      <Input type="password" value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })} required data-testid={testid} />
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-md" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>Ganti Password</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-3">
          {field('current', 'Password Saat Ini', 'change-pw-current')}
          {field('next', 'Password Baru', 'change-pw-new')}
          {field('confirm', 'Ulangi Password Baru', 'change-pw-confirm')}
          <p className="text-xs text-slate-500">Minimal 8 karakter, mengandung huruf besar dan angka. Anda akan diminta login ulang setelah berhasil.</p>
          <div className="flex justify-end gap-2 pt-2">
            <Button type="button" variant="outline" onClick={() => handleOpenChange(false)} data-testid="change-pw-cancel">Batal</Button>
            <Button type="submit" className="bg-red-600 hover:bg-red-700" disabled={saving} data-testid="change-pw-submit">
              {saving ? 'Menyimpan...' : 'Simpan Password'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
